export const CLASS_UPDATE_LIST = 'CLASS_UPDATE_LIST'
export const CLASS_UPDATE_LIST_METHOD = 'CLASS_UPDATE_LIST_METHOD'
export const CLASS_UPDATE_LIST_STUDENTS = 'CLASS_UPDATE_LIST_STUDENTS'
export const CLASS_UPDATE_LIST_TEACHERS = 'CLASS_UPDATE_LIST_TEACHERS'
export const CLASS_UPDATE_FORM_ERROR = 'CLASS_UPDATE_FORM_ERROR'
export const CLASS_UPDATE_FORM = 'CLASS_UPDATE_FORM'
export const CLASS_UPDATE_FORM_FIELD = 'CLASS_UPDATE_FORM_FIELD'
export const CLASS_UPDATE_PREVIEW = 'CLASS_UPDATE_PREVIEW'
export const CLASS_UPDATE_DIALOG = 'CLASS_UPDATE_DIALOG'
export const CLASS_UNIT_OF_LEARNING_UPDATE_FORM = 'CLASS_UNIT_OF_LEARNING_UPDATE_FORM'

export const updateClassesList = (curriculumId, { data, count, students, teachers, totalIds }) => ({
  type: CLASS_UPDATE_LIST,
  payload: { curriculumId, data, count, students, teachers, totalIds }
})
export const updateClassesListMethod = (curriculumId, method, data) => ({
  type: CLASS_UPDATE_LIST_METHOD,
  payload: { curriculumId, method, data }
})
export const updateClassesListStudents = (curriculumId, list) => ({
  type: CLASS_UPDATE_LIST_STUDENTS,
  payload: { curriculumId, list }
})
export const updateClassesListTeachers = (curriculumId, list) => ({
  type: CLASS_UPDATE_LIST_TEACHERS,
  payload: { curriculumId, list }
})
export const updateClassFormError = (error = null) => ({
  type: CLASS_UPDATE_FORM_ERROR,
  payload: error
})
export const updateClassForm = (data) => ({
  type: CLASS_UPDATE_FORM,
  payload: data
})
export const updateClassFormField = (field, value) => ({
  type: CLASS_UPDATE_FORM_FIELD,
  payload: { field, value }
})
export const updateClassPreview = (preview = null) => ({
  type: CLASS_UPDATE_PREVIEW,
  payload: preview
})
export const updateClassDialog = (open = false, type, form) => ({
  type: CLASS_UPDATE_DIALOG,
  payload: { open, type, form }
})
export const updateUnitOfLearningForm = (data) => ({
  type: CLASS_UNIT_OF_LEARNING_UPDATE_FORM,
  payload: data
})